import { createLeadWithTracking } from "../../shared/openaiLeadTracking.mjs";
import { useState } from "react";
import LeadOtpVerification from "@/components/common/LeadOtpVerification";

export default function PGLeadModal({ marks, onClose, onComplete }) {
  const [formData, setFormData] = useState({ firstName: "", lastName: "", email: "", phone: "" });
  const [verified, setVerified] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const update = (event) => setFormData((current) => ({ ...current, [event.target.name]: event.target.value }));

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!verified) {
      setError("Please verify your phone number before continuing.");
      return;
    }
    setSubmitting(true);
    setError("");
    try {
      const name = `${formData.firstName} ${formData.lastName}`.trim();
      const adminUrl = process.env.NEXT_PUBLIC_ADMIN_URL;
      if (adminUrl) {
        const response = await createLeadWithTracking(`${adminUrl}/api/leads`, {
          method: "POST",
          headers: { "Content-Type": "application/json", "x-secret-key": process.env.NEXT_PUBLIC_SECRET_KEY },
          body: JSON.stringify({ name, email: formData.email, phone: `+91${formData.phone}`, leadSource: "PG_Rank_Prediction_Form", neetScore: marks }),
        });
        if (!response.ok) throw new Error("Lead submission failed");
      }
      // Same 6-month window as the UG predictor, so returning users skip the form.
      const expiry = Date.now() + 6 * 30 * 24 * 60 * 60 * 1000;
      localStorage.setItem("pgRankLeadSubmitted", JSON.stringify({ value: true, expiry }));
      onComplete();
    } catch (submissionError) {
      console.error("PG rank lead submission error:", submissionError);
      setError("We could not submit your details. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-slate-950/70 px-4 py-6 backdrop-blur-sm" role="dialog" aria-modal="true" aria-labelledby="pg-lead-title">
      <div className="relative max-h-[95vh] w-full max-w-2xl overflow-y-auto rounded-2xl bg-white p-6 shadow-2xl sm:p-8">
        <button type="button" onClick={onClose} aria-label="Close lead form" className="absolute right-4 top-3 text-2xl font-bold text-slate-400 transition hover:text-[#ff9245]">×</button>
        <h2 id="pg-lead-title" className="mt-2 text-center text-lg font-semibold text-[#1A374D] sm:text-xl">Fill your details to get Your rank</h2>
        <p className="mt-2 text-center text-sm text-slate-500">Your NEET PG score: <strong className="text-[#163a3b]">{marks}/720</strong></p>
        <form onSubmit={handleSubmit} className="mt-7 space-y-3">
          <div className="grid gap-3 sm:grid-cols-2"><input name="firstName" placeholder="First Name" className="w-full rounded border p-3 text-[#000]" onChange={update} required /><input name="lastName" placeholder="Last Name" className="w-full rounded border p-3 text-[#000]" onChange={update} required /></div>
          <input name="email" type="email" placeholder="Email" className="w-full rounded border p-3 text-[#000]" onChange={update} required />
          <LeadOtpVerification phone={formData.phone} otpEnabled={false} onPhoneChange={(value) => setFormData((current) => ({ ...current, phone: value }))} inlinePhoneField countryCodePrefix="+91" phonePlaceholder="Phone Number" onVerifiedChange={setVerified} />
          {error && <p className="text-center text-sm font-medium text-red-600" role="alert">{error}</p>}
          <button type="submit" disabled={submitting} className="mx-auto block rounded-full bg-[#ff9245] px-7 py-3 text-base font-semibold text-white transition hover:bg-white hover:text-[#ff9245] hover:ring-1 hover:ring-[#ff9245] disabled:cursor-not-allowed disabled:opacity-60">{submitting ? "Submitting..." : "➜ Submit"}</button>
        </form>
      </div>
    </div>
  );
}
